const changePercentage = (diff,dissPrice)=>{
  const progressBar = document.querySelector('.main_offer_pdp_progress_percent');
  const diffPer = (diff/dissPrice)*100;
  progressBar.style.width = `${Math.ceil(100 - diffPer)}%`
}
async function checkBYOBTagInCart() {
  try {
    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();

    const byobTags = ['BYOB', 'AuraBYOB', 'Bonanza'];
    let hasBYOBProduct = false;

    for (const item of cartData.items) {
      // Try checking directly from cart item if possible
      const tags = item.tags || [];

      if (byobTags.some(tag => tags.includes(tag))) {
        hasBYOBProduct = true;
        break;
      }

      // Fallback to fetching product tags
      const productRes = await fetch(`/products/${item.handle}.js`);
      const productData = await productRes.json();

      if (byobTags.some(tag => productData.tags.includes(tag))) {
        hasBYOBProduct = true;
        break;
      }
    }

    const offerButton = document.querySelector('button.collapsible-custom2.custom_offer_class_last_offer');
    const existingNote = document.querySelector('.byob-warning-note');

    // Remove any existing note to prevent duplication
    if (existingNote) {
      existingNote.remove();
    }

    if (hasBYOBProduct && offerButton) {
      offerButton.style.display = 'none';

      const message = document.createElement('div');
      message.textContent = 'Note: No other discounts can be applied or combined with BYOB.';
      message.classList.add('byob-warning-note');
      message.style.fontWeight = 'bold';
      message.style.marginTop = '10px';
      message.style.color = 'red';

      offerButton.parentNode.insertBefore(message, offerButton);
    } else if (offerButton) {
      offerButton.style.display = 'block';
    }
  } catch (error) {
    console.error('Failed to check BYOB tag in cart:', error);
  }
}



document.addEventListener('DOMContentLoaded', checkBYOBTagInCart);
document.addEventListener('cart-updated', checkBYOBTagInCart); // Add this to recheck on cart updates


// const cstmGetCartValue = async () => {
//   let isPresent = false;
//   const res = await fetch('/cart.json');
//   const data = await res.json();

//   const checkBox = document.querySelector(".checkbox_text_parent_flex input"); 
//   const consultId = parseInt(checkBox?.value);
//   if(checkBox?.checked){
//   const {items} = data;
//   for(let i=0;i<items.length;i++){
//     const product = items[i];
//     if(product.variant_id == consultId){
//       isPresent = true;
//       break;
//     }
//   }

//   if(!isPresent){
//   let formdata = {
//   items: [
//   {
//   'id': consultId,
//   'quantity': 1
//   }
//   ],
//   sections: ['main-cart', 'cart-icon-bubble']
//   };
    
//   fetch('/cart/add.js', {
//   method: "POST",
//   headers: {
//   'Content-Type': "application/json"
//   },
//   body: JSON.stringify(formdata)
//   }).then((response) => {
//   return fetch('?section_id=helper-cart');
//   }).then(response => response.text())
// 				.then(text => {

// 					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
// 					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
// 					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

// 					const cartItems = document.getElementById('AjaxCartForm');
// 					cartItems.innerHTML = cartFormInnerHTML;
// 					cartItems.ajaxifyCartItems();

// 					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
// 						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
// 					});
// 					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
// 						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
// 					});

// 					if ( alert !== null ) {
// 						this.form.prepend(alert);
// 					} 

// 					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
// 					const event = new Event('cart-updated');
// 					this.dispatchEvent(event);

//                     if(document.body.classList.contains('template-product-latest_pdp')){
//                         checkDisscount();
//                     }              

// 				}).catch((error) => {
//   console.error('Error: ', error);
//   });
    
//   }
//     checkBox.checked = false;
//   }
  
//   return data?.original_total_price / 100;
// }
const cstmGetCartValue = async () => {
  let isPresent = false;
  const res = await fetch('/cart.json');
  const data = await res.json();

  const checkBox = document.querySelector(".inner_row_check2 input");
  const selectDropdown = document.querySelector("#variant-select");

  
  if (checkBox?.checked && selectDropdown) {
    const selectedVariantId = parseInt(selectDropdown.value);

    const { items } = data;
    for (let i = 0; i < items.length; i++) {
      const product = items[i];
      // if (product.variant_id == selectedVariantId) {
      //   isPresent = true;
      //   break;
      // }
    }

    if (!isPresent) {
      let formdata = {
        items: [
          {
            'id': selectedVariantId,
            'quantity': 1
          }
        ],
        sections: ['main-cart', 'cart-icon-bubble']
      };

      fetch('/cart/add.js', {
        method: "POST",
        headers: {
          'Content-Type': "application/json"
        },
        body: JSON.stringify(formdata)
      })
      .then((response) => {
        return fetch('?section_id=helper-cart');
      })
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });
        document.querySelectorAll('[data-header-cart-total').forEach(elm => {
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        });

        if (alert !== null) {
          this.form?.prepend(alert);
        }

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

        const event = new Event('cart-updated');
document.dispatchEvent(new Event('cart-updated')); // ✅ GLOBAL EVENT

        document.dispatchEvent(new Event('cart-updated')); // ✅ GLOBAL EVENT


        if (document.body.classList.contains('template-product-latest_pdp') || document.body.classList.contains('template-product-new_pdp_9-1-25')) {
          checkDisscount();
        }
      })
      .catch((error) => {
        console.error('Error: ', error);
      });
    }
    checkBox.checked = false;
  } else {
    // Notify user that both checkbox and dropdown selection are required
    // alert("Please select a variant and check the checkbox before adding to the cart.");
  }

  return data?.original_total_price / 100;
};

const checkDisscount = async () => {
  const cartValue = await cstmGetCartValue();
  let message = "";

  const offerPrices = Array.from(document.querySelectorAll('.offers_popup_main .offer_block_info .min_order_value'));

  // Sort offerPrices by the numeric value in ascending order
  offerPrices.sort((a, b) => parseInt(a.innerText.split("₹")[1]) - parseInt(b.innerText.split("₹")[1]));

  for (let i = 0; i < offerPrices.length; i++) {
    const item = offerPrices[i];
    const dissPrice = parseInt(item.innerText.split("₹")[1]);
    const currentDisccount = offerPrices[i-1];
    console.log(currentDisccount,"currentDisccount")
    const currentCoupenCode = currentDisccount?.parentElement?.parentElement?.querySelector(".coupen_code").innerText.trim(); 
    const priceMoney = currentDisccount?.parentElement?.parentElement?.parentElement?.querySelector(".coupon_percent").getAttribute("price_money");
    console.log(priceMoney,'priceMoney');
    const currentPercent = parseInt(currentDisccount?.parentElement?.parentElement?.parentElement?.querySelector(".coupon_percent").innerText.split(" ")[0].split("%")[0]);
    const buyForPrice = cartValue - Math.ceil((cartValue*currentPercent)/100);
    const coupenCode = item.parentElement.parentElement.querySelector(".coupen_code").innerText.trim();
    const offerTextEl = document.querySelector(".main_offer_pdp .offer_text");
    const offerCode = document.querySelector(".offer_code span");
    const mainOffer = document.querySelector('.main_offer_pdp_info_text');
    const codeContainer = document.querySelector(".main_offer_pdp_head_right");
    
     offerTextEl.innerText = `Unlock a coupon by adding products`;
        offerCode.innerText = `No coupon found`;
    if (cartValue < dissPrice) {
      // alert("in if")
      const coupenPercentElement = item.parentElement.parentElement.parentElement.querySelector(".coupon_percent");
      const isMoneyRupee = coupenPercentElement.getAttribute('price_money');
      const buyPriceEl = document.querySelector(".buy_for_price");
      const copyBtn = document.querySelector('.main_offer_pdp_head_right .copy_text_logo');

      if(cartValue < offerPrices[0] ){
        offerTextEl.innerText = `Unlock a coupon by adding products`;
        copyBtn.style.pointerEvents = 'none';
      }
      else{
        if(!currentCoupenCode){
          codeContainer.style.display = 'none';
          offerCode.innerText = "No coupon found"
        }
        else{
          codeContainer.style.display = 'block';
          offerCode.innerText = currentCoupenCode;
        offerTextEl.innerText = `Coupon unlocked!`
        }

        buyPriceEl.innerText = buyForPrice;
        copyBtn.style.pointerEvents = 'all';
      }

      let coupenPercent = 0;
      if(isMoneyRupee){
        coupenPercent = isMoneyRupee;
      }
      else{
        coupenPercent = coupenPercentElement.innerText.split(" ")[0];
      }
        let difference = dissPrice - cartValue
        message = `Add more items of ₹${difference} to get ${coupenPercent} OFF on all orders above ₹${dissPrice}`;
        mainOffer.innerText = message;
        changePercentage(difference,dissPrice);
      
      break; 
    }
    else{
      // alert("in else")
      const activeDisscount = item.parentElement.parentElement.parentElement.parentElement;
      activeDisscount.classList.add('activeDisscount')
      mainOffer.innerText = 'You are eligible for the highest code';
      offerCode.innerText = coupenCode;
      offerTextEl.innerText = `Coupon unlocked!`
      changePercentage(0,100);
    }
  }

  document.body.style.overflow = 'unset'
  console.log("Doneee")
}

checkDisscount();


if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
                  
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					// const event = new Event('cart-updated');
					document.dispatchEvent(new Event('cart-updated')); // ✅ global
                    checkDisscount();

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}
document.dispatchEvent(new Event('cart-updated'));
}
